<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-flex lg4 md5 sm8 xl3 xs12>
        <v-card class="elevation-12">
          <v-toolbar extension-height="0">
            <v-toolbar-title class="headline text-uppercase">
              <span>EUHFORIA</span>
              <span class="font-weight-light">online</span>
            </v-toolbar-title>
            <v-progress-linear
              :active="$wait.is('busy')"
              :indeterminate="true"
              class="ma-0"
              height="4"
              slot="extension"
              style="top: -2px;"
            >Progress?</v-progress-linear>
          </v-toolbar>

          <v-card-text>
            <div class="mt-2">
              <v-form>
                <v-text-field disabled label="Email" name="email" prepend-icon="email" type="text" v-model="user.email"></v-text-field>
                <v-text-field
                  disabled
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  v-if="$route.query.token"
                  v-model="user.password"
                ></v-text-field>
                <v-text-field
                  disabled
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  v-if="$route.query.token"
                  v-model="user.repeatPassword"
                ></v-text-field>
              </v-form>
              <div class="text-xs-center">
                <v-btn @click="setPassword" class="mb-3" disabled large v-if="$route.query.token">Set password</v-btn>
                <v-btn @click="resetPassword" class="mb-3" disabled large v-else>Reset password</v-btn>
                <p>
                  Remember your password?
                  <router-link :to="{name: 'signin'}">Sign in</router-link>
                </p>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.v-toolbar__extension {
  padding: 0px !important;
}
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import { RESET_PASSWORD, SET_PASSWORD } from '@/graphql.gql';

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
        repeatPassword: '',
      },
    };
  },
  validations: {
    user: {
      email: {
        required,
      },
    },
  },
  methods: {
    async resetPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$snackbar.show('Please, fill the credentials.');
        return;
      }
      try {
        this.$wait.start('busy');
        await this.$apollo.mutate({
          mutation: RESET_PASSWORD,
          variables: { email: this.user.email },
        });
      } catch (error) {
        this.$snackbar.show('Please, double-check your credentials and try again.');
      } finally {
        this.$wait.end('busy');
      }
      this.$snackbar.show('An email with password reset link has been sent to you.');
    },
    async setPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$snackbar.show('Please, fill the credentials.');
        return;
      }
      try {
        this.$wait.start('busy');
        await this.$apollo.mutate({
          mutation: SET_PASSWORD,
          variables: {
            input: { email: this.user.email, password: this.user.password, token: this.$route.query.token },
          },
        });
      } catch (error) {
        this.$snackbar.show('Please, double-check your credentials and try again.');
      } finally {
        this.$wait.end('busy');
      }
      this.$snackbar.show('Your password has now been reset.');
    },
  },
};
</script>
